module.exports = __webpack_public_path__ + "assets/img/white-eagle.13d9f6a5.jpg";